import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import {
  RECEIVE_CREATE_DEMO_ACCESS,
  RECEIVE_CREATE_DEMO_ACCESS_ERROR,
  REQUEST_CREATE_DEMO_ACCESS,
} from "@/redux/constants/contact_form";
import * as contactFormApi from "@/api/contact_form";
import { showNotification } from "@/redux/actions/notification";

function requestCreateDemoAccess() {
  return {
    type: REQUEST_CREATE_DEMO_ACCESS,
  };
}

function receiveCreateDemoAccess() {
  return {
    type: RECEIVE_CREATE_DEMO_ACCESS,
  };
}

function receiveCreateDemoAccessError(error) {
  return {
    type: RECEIVE_CREATE_DEMO_ACCESS_ERROR,
    error,
  };
}

export function createDemoAccess(payload, callback) {
  return async function (dispatch) {
    dispatch(requestCreateDemoAccess());

    const response = await contactFormApi.createDemoAccess(payload);
    if (response.ok) {
      dispatch(receiveCreateDemoAccess());
      dispatch(
        showNotification({
          ...DEFAULT_NOTIFICATION_PAYLOAD,
          message: {
            ...DEFAULT_NOTIFICATION_PAYLOAD.message,
            title: "Thanks for signing up for your free trial of Fundview!",
            description:
              "Since we're a broker-only platform (no borrowers), we verify that all new users are active CRE finance brokers. This can take up to 24 hours. If we're unable to verify your credentials through our standard process, we'll reach out directly to confirm.\n" +
              "Once verified, you'll receive an email with your login details.",
            options: {
              variant: NOTIFICATION_VARIANTS.SUCCESS,
              persist: true,
            },
          },
        }),
      );
      if (callback) callback();
    } else {
      dispatch(receiveCreateDemoAccessError(response.userDescription));
      dispatch(
        showNotification({
          ...DEFAULT_NOTIFICATION_PAYLOAD,
          message: {
            title: "Error",
            description: response.data.userDescription,
            options: {
              variant: NOTIFICATION_VARIANTS.ERROR,
            },
          },
        }),
      );
    }
  };
}
